import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})
export class ExecuteService {

  constructor(public rest: RestService) { }
  private setBrowserIfEmpty(execution) {
    if (!execution.browser)
      execution["browser"] = ["Chrome"]
    return execution;
  }
  public executeSuite(execution, csvFile: File, apkFile: File, suiteResourceConfig?: any) {
    const formData: FormData = new FormData();
    let projectId = localStorage.getItem("projectId");
    execution = this.setBrowserIfEmpty(execution);
    let request = {
      project: { _id: projectId },
      execution: execution,
      suite_resource_config: suiteResourceConfig
    };

    const blobOverrides = new Blob([JSON.stringify(request)], {
      type: 'application/json',
    });

    formData.append('req', JSON.stringify(request));
    
    // Append CSV file for web testing
    if (csvFile)
      formData.append('file', csvFile, csvFile.name);
    else
      formData.append('file', new Blob(), '');
    
    // Append APK file for mobile testing
    if (apkFile)
      formData.append('apk', apkFile, apkFile.name);
    else
      formData.append('apk', new Blob(), '');

    let params = new HttpParams();
    params.append('req', JSON.stringify(request));

    return this.rest.postWithParams('executeSuite', formData, params)
  }

  public executeTestCaseSuite(execution, executionConfig, testCaseId: string, isDefaultCsvFile: boolean, csvFile: File, apkFile: File, suiteResourceConfig?: any) {
    const formData: FormData = new FormData();
    let projectId = localStorage.getItem("projectId");
    execution = this.setBrowserIfEmpty(execution);
    let normalizedTestCaseId: any = testCaseId;
    if (normalizedTestCaseId && typeof normalizedTestCaseId === 'object' && normalizedTestCaseId.$oid) {
      normalizedTestCaseId = normalizedTestCaseId.$oid;
    }

    let request = {
      project: { _id: projectId },
      execution: execution,
      isDefaultCsv: isDefaultCsvFile,
      test_case_id: normalizedTestCaseId,
      executionConfig: executionConfig,
      suite_resource_config: suiteResourceConfig
    };

    const blobOverrides = new Blob([JSON.stringify(request)], {
      type: 'application/json',
    });

    formData.append('req', JSON.stringify(request));
    
    // Append CSV file for web testing
    if (csvFile)
      formData.append('file', csvFile, csvFile.name);
    else
      formData.append('file', new Blob(), '');
    
    // Append APK file for mobile testing
    if (apkFile)
      formData.append('apk', apkFile, apkFile.name);
    else
      formData.append('apk', new Blob(), '');

    let params = new HttpParams();
    params.append('req', JSON.stringify(request));

    return this.rest.postWithParams('executeTestCaseSuite', formData, params)
  }

  public executeTestCaseSuiteForDb2(execution, executionConfig, testCaseId: string, isDefaultCsvFile: boolean, csvFile: File, apkFile: File, suiteResourceConfig?: any) {
    const formData: FormData = new FormData();
    execution = this.setBrowserIfEmpty(execution);
    let projectId = localStorage.getItem('projectIdDb2');
    let normalizedTestCaseId: any = testCaseId;
    if (normalizedTestCaseId && typeof normalizedTestCaseId === 'object' && normalizedTestCaseId.$oid) {
      normalizedTestCaseId = normalizedTestCaseId.$oid;
    }

    let request:any = {
      project: { _id: projectId },
      execution: execution,
      isDefaultCsv: isDefaultCsvFile,
      test_case_id: normalizedTestCaseId,
      executionConfig: executionConfig

    };

    const blobOverrides = new Blob([JSON.stringify(request)], {
      type: 'application/json',
    });

    if (suiteResourceConfig) {
      request.suite_resource_config = suiteResourceConfig;
    }

    formData.append('req', JSON.stringify(request));
    
    // Append CSV file for web testing
    if (csvFile)
      formData.append('file', csvFile, csvFile.name);
    else
      formData.append('file', new Blob(), '');
    
    // Append APK file for mobile testing
    if (apkFile)
      formData.append('apk', apkFile, apkFile.name);
    else
      formData.append('apk', new Blob(), '');

    let params = new HttpParams();
    params.append('req', JSON.stringify(request));

    return this.rest.postWithParams('executeTestCaseSuiteForDb2', formData, params)
  }

  public getDifference(statusModel, reportId) {
    return this.rest.get('getDifference', statusModel['_id'], reportId);
  }

  public executeSuitedb2(execution, csvFile: File, apkFile: File, suiteResourceConfig?: any) {
    const formData: FormData = new FormData();
    execution = this.setBrowserIfEmpty(execution);
    let projectId = localStorage.getItem('projectIdDb2');
    let request:any = {
      project: { _id: projectId },
      execution: execution

    };

    const blobOverrides = new Blob([JSON.stringify(request)], {
      type: 'application/json',
    });

    if (suiteResourceConfig) {
      request.suite_resource_config = suiteResourceConfig;
    }

    formData.append('req', JSON.stringify(request));
    
    // Append CSV file for web testing
    if (csvFile)
      formData.append('file', csvFile, csvFile.name);
    else
      formData.append('file', new Blob(), '');
    
    // Append APK file for mobile testing
    if (apkFile)
      formData.append('apk', apkFile, apkFile.name);
    else
      formData.append('apk', new Blob(), '');

    let params = new HttpParams();
    params.append('req', JSON.stringify(request));

    return this.rest.postWithParams('executeSuitedb2', formData, params)
  }

  public executeFeature(execution) {
    let projectId = localStorage.getItem("projectId");
    let data = {
      project: { _id: projectId },
      execution: execution
    };
    return this.rest.put('executeFeature', data)
  }

  public executeScenario(execution) {
    let projectId = localStorage.getItem("projectId");
    let data = {
      project: { _id: projectId },
      execution: execution
    };
    return this.rest.put('executeScenario', data)
  }
  public saveToDb(execution) {
    let projectId = localStorage.getItem("projectId");
    let data = {
      project: { _id: projectId },
      execution: execution
    };
    return this.rest.put('executeScenario', data)
  }

  public executeStop(id): Observable<any> {
    let data = {
      execution: { _id: id }
    }
    return this.rest.put('executeStop', data);
  }

  public executeRerun(id): Observable<any> {
    let data = {
      execution: { _id: id }
    }
    return this.rest.put('executeRerun', data);
  }

  public executeStop2(id): Observable<any> {
    let data = {
      execution: { _id: id }
    }
    return this.rest.put('executeStop2', data);
  }

  public executeRerun2(id): Observable<any> {
    let data = {
      execution: { _id: id }
    }
    return this.rest.put('executeRerun2', data);
  }

  public deleteExeReport(id): Observable<any> {
    return this.rest.delete('deleteExeReport', id);
  }

  public deleteExeReport2(id): Observable<any> {
    return this.rest.delete('deleteExeReport2', id);
  }

  public isTestCaseGenerated(reportID): Observable<any> {
    return this.rest.get('isTestCaseGenerated', reportID);
  }

  public getReportById(reportID): Observable<any> {
    return this.rest.get('getReportById', reportID);
  }
}
